<template>
    <div class="flex-grow-1 d-flex justify-content-end bg-white"
         :class="{'bg-hover-light-secondary': !isWaitingForIntegration && !allPositionsRefunded}">
        <div class="d-flex flex-column justify-content-center w-100 w-md-auto">
            <div class="px-md-10">
                <button v-if="showCancelButton"
                        class="btn btn-danger w-100 w-md-auto"
                        @click="rejectOrder"
                >
                    <i class="fas fa-reply"/>
                    {{ __('actions.order.reject') }}
                </button>
                <Link
                        v-if="showRefundButton"
                        :href="$route('order.refund', [store.id, order.url_key])"
                        as="button"
                        class="btn btn-danger w-100 w-md-auto"
                        :disabled="isWaitingForIntegration"
                        :only="['refundOptions']"
                >
                    <i class="fas fa-hand-holding-usd"/>
                    {{ __('actions.cancel_refund') }}
                </Link>
            </div>
        </div>
    </div>
</template>

<script>
import {OrderState} from '@composables/orderStates';
import { Link } from '@inertiajs/vue2';

export default {
    components: {Link},

    props: {
        store: Object,
        order: Object,
    },

    methods: {
        rejectOrder() {
            Swal.fire({
                title: this.__('orders.details.reject_modal.title'),
                text: this.__('orders.details.reject_modal.text'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-danger m-0',
                confirmButtonText: this.__('actions.order.reject'),
                cancelButtonText: this.__('actions.abort'),
            }).then((result) => {
                if (result.value) {
                    this.$emit('transition', OrderState.Rejected);
                }
            });
        },
    },

    computed: {
        OrderState() {
            return OrderState;
        },

        logsByState(){
            return this.order.logs_by_state;
        },

        showCancelButton() {
            return !this.logsByState.hasOwnProperty(OrderState.Confirmed)
                && !this.logsByState.hasOwnProperty(OrderState.PickedUp)
                && !this.logsByState.hasOwnProperty(OrderState.ReadyForPickup)
                && !this.logsByState.hasOwnProperty(OrderState.PickedUp)
                && !this.logsByState.hasOwnProperty(OrderState.Refunded)
                && !this.logsByState.hasOwnProperty(OrderState.Rejected)
                && this.order.state !== OrderState.Cancelled
                && !this.isFinalStateReached;
        },

        showRefundButton() {
            return !this.isRefunded && this.logsByState.hasOwnProperty(OrderState.Confirmed) && !this.isFinalStateReached;
        },

        isFinalStateReached() {
            return [
                OrderState.Cancelled,
                OrderState.Rejected,
                OrderState.Refunded
            ].includes(this.order.state)
        },

        isRefunded() {
            return this.logsByState.hasOwnProperty(OrderState.Refunded);
        },

        isWaitingForIntegration() {
            return this.order.state === OrderState.WaitForIntegration;
        },

        allPositionsRefunded() {
            let positions = {};

            //Fill with original values
            for (let item of this.order.items) {
                positions[item.identifier] = item.quantity;
            }

            //Substract each refunded quantity
            for (let refund of this.order.refunds) {
                positions[refund.identifier] -= refund.quantity_refunded;
            }

            //Check if there's items left to refund
            for (let position of Object.values(positions)) {
                if (position > 0) {
                    return false;
                }
            }

            return true;
        },
    },
};
</script>
